module.exports = __webpack_public_path__ + "img/icons8-pdf.ba132ed7.svg";